module.exports = function() {
  return new Worker(__webpack_public_path__ + "0ffcd48ce31812a420df.worker.js");
};